import About from "../Components/About/About";
import PageWrapper from "../Components/PageWrapper/PageWrapper";

export default function AboutMe() {
  return (
    <PageWrapper>
      <About />
    </PageWrapper>
  );
}
